import React from 'react'
import { SVGIconProps } from '../types'
const SvgToys = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23z" />
  </svg>
)
export default SvgToys
